import axios from 'axios'
import PMBTotalFooter from 'components/PMBTotalFooter'
import {
  setIsModalOpenAddAddressBook,
  setSearchAddressBook,
} from 'features/private-views/address-book/addressBookSlice'
import InputAddressBook from 'features/private-views/address-book/InputAddressBook'
import ModalAddContact from 'features/private-views/address-book/ModalAddContact'
import { uploadFile } from 'features/private-views/sell-commodity/sellCommodityAction'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import { useAbilityAccess } from 'hooks/useAbilityAccess'
import moment from 'moment-timezone'
import { useSnackbar } from 'notistack'
import { useEffect, useRef, useState } from 'react'
import { AlertCircle, Calendar, X } from 'react-feather'
import Flatpickr from 'react-flatpickr'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Badge,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap'
import { emailCheck } from 'utils/emailCheck'
import { URL_DETAIL_TRANSACTION } from 'utils/pathUrl'
import {
  BUSINESS_TRANSACTION_PURCHASE,
  MAKE,
  MANAGE,
} from 'utils/subjectActions'
import pakTani from '../../assets/icons/Pak Tani.png'
import ProfilePic from 'components/PMBProfilePic'
import { apiEndpoint } from '../../utility/Utils'
import { setNumberStep } from './commodityPurchaseSlice'
import ComodityForm from './ComodityForm'
import ModalDrafts from './ModalDrafts'
import ModalUnverifSeller from './ModalUnverifSeller'

const AddComodity = () => {
  const lastPath = localStorage.getItem('lastPathBeforeNavigate')
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { token } = useSelector((e) => e.auth)
  const { profile, ownerData } = useSelector((e) => e.dashboard)
  const { isModalOpenAddAddressBook } = useSelector((e) => e.addressBook)
  const { total } = useSelector((s) => s.comodityPurchase)

  const isManual = location.state?.isManual

  const [dataDraft, setDataDraft] = useState(null)
  const [tempDraft, setTempDraft] = useState(null)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [dataSeller, setDataSeller] = useState('')
  const [userData] = useState({})
  const [isSet, setIsSet] = useState(false)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isOpenModalDraft, setIsOpenModalDraft] = useState(false)
  const [errMsgPhone, setErrMsgPhone] = useState('')
  const [errMsg, setErrMsg] = useState('')
  const [alreadyReceived, setAlreadyReceived] = useState(false)
  const [fileNames, setFileNames] = useState([])
  const [files, setFiles] = useState([])
  const [savedContacts, setSavedContacts] = useState([])
  const [selectedDate, setSelectedDate] = useState(
    moment(new Date()).format('YYYY-MM-DD'),
  )
  const [selectedContact, setSelectedContact] = useState(null)
  const [isFetchingAddressBook, setIsFetchingAddressBook] = useState(false)
  const [disable, setDisable] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const toggleModal = () => {
    setIsOpenModal(!isOpenModal)
  }
  const toggleOpenCloseAddContact = () => {
    dispatch(setIsModalOpenAddAddressBook(!isModalOpenAddAddressBook))
  }

  const toggleOpenModalDraft = () => {
    dispatch(setIsOpenModalDraft(!isOpenModalDraft))
  }

  const addressBookRef = useRef(null)

  const makePurchase = useAbilityAccess({
    action: MAKE,
    subject: BUSINESS_TRANSACTION_PURCHASE,
  })

  const managePurchase = useAbilityAccess({
    action: MANAGE,
    subject: BUSINESS_TRANSACTION_PURCHASE,
  })

  const handleCheckNumber = async (phoneOrEmail) => {
    try {
      setErrMsgPhone('')
      if (phoneOrEmail) {
        const { data } = await axios.get(
          `${apiEndpoint}/api/v1/bussines/transaction/checkuser?search=${encodeURIComponent(phoneOrEmail)}&type=BUY`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        if (data?.status === 'REGISTERED') {
          setDataSeller(data)
        } else {
          setDataSeller('')
          toggleModal()
        }
      }
    } catch (error) {
      setDataSeller('')
      console.warn(error)
      if (!error.response) {
        setErrMsgPhone('Silahkan cek koneksi internet Anda.')
      } else {
        setErrMsgPhone(error.response.data.message)
      }
    }
  }

  const handleSelectedContact = (contact) => {
    setDataSeller(contact)
    setSelectedContact(contact)
  }

  const getProfile = async () => {
    try {
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return data
    } catch (error) {
      console.warn(error)
    }
  }

  const handleFinished = async (response) => {
    try {
      setIsSubmitted(true)
      if (response) {
        const updatedDataComodities = response?.dataComodities?.map((item) => ({
          ...item,
          price: item.price === '' ? 0 : item.price,
        }))

        const allPricesAreZero = updatedDataComodities.every(
          (item) => item.price === 0,
        )

        const obj = {
          ...response,
          dataComodities: updatedDataComodities,
          dataSeller: dataSeller,
          alreadyReceived: alreadyReceived,
          files: files.map((e) => e.fileUrl),
          additionalFiles: response?.additionalFiles || [],
          additionalFileNames: response?.additionalFileNames || [],
          fileNames: fileNames,
          trxDate: selectedDate,
        }
        localStorage.setItem('userData', JSON.stringify(obj))

        if (isManual) {
          const dataProfile = await getProfile()
          setIsSet(false)
          navigate('/konfirmasi-pin-transaksi', {
            state: {
              dataProfile: dataProfile,
              userData: obj,
              dataState: obj,
              isManual: true,
            },
          })
          return
        }

        if (
          dataSeller?.status === 'REGISTERED' &&
          dataSeller?.profileStatus === 'VERIFIED' &&
          (dataSeller?.isLogin || alreadyReceived) &&
          !allPricesAreZero
        ) {
          const obj = {
            ...response,
            dataComodities: updatedDataComodities,
            dataSeller: dataSeller,
            alreadyReceived: alreadyReceived,
            files: files.map((e) => e.fileUrl),
            additionalFiles: response?.additionalFiles || [],
            additionalFileNames: response?.additionalFileNames || [],
            fileNames: fileNames,
            trxDate: selectedDate,
          }
          localStorage.setItem('userData', JSON.stringify(obj))
          setIsSet(false)
          navigate('/transaksi-pembelian-pembayaran')
        } else {
          const dataProfile = await getProfile()
          const isEmail = emailCheck(phoneNumber)
          const obj = {
            userId: dataProfile?.ownerData?.userId,
            item: response?.dataComodities?.map((e) => {
              return {
                SKU: e?.comodity?.sku ?? e?.comodity?.SKU,
                // nameItem: e?.comodity?.label,
                // imageUrl: e?.comodity?.img ?? e?.comodity?.linkFoto,
                unit: e?.unit?.value,
                amount: Number(
                  e?.quantity
                    ?.replace?.(/\./g, '')
                    ?.replace?.(/,/g, '.')
                    ?.slice?.(0, 15),
                ),
                price:
                  e?.price === ''
                    ? 0
                    : Number(
                      e?.price
                        ?.replace(/\./g, '')
                        ?.replace(/,/g, '.')
                        ?.slice(0, 15),
                    ),
              }
            }),
            project: response?.project ? response?.project : null,
            order: {
              type: 'BUY',
              note: response?.notes,
              transaction_number: response?.customNumber,
              autoRelease: alreadyReceived,
              escrowFiles: files.map((e) => e.fileUrl),
              files: response?.additionalFiles || [],
            },
            buyer: {
              fullName:
                dataProfile?.ownerData?.name ||
                ownerData?.name ||
                profile?.data?.ownerData?.name,
              phoneNumber:
                dataProfile?.ownerData?.phoneNumber ||
                ownerData?.phoneNumber ||
                profile?.data?.ownerData?.phoneNumber,
              userId:
                dataProfile?.ownerData?.userId ||
                ownerData?.userId ||
                profile?.data?.ownerData?.userId,
            },
            seller: {
              fullName: dataSeller?.fullName,
              phoneNumber: dataSeller?.phoneNumber ?? phoneNumber,
              bankCode: dataSeller?.bankCode,
              bankAccountName: dataSeller?.bankAccountName,
              bankAccountNumber: dataSeller?.bankAccountNumber,
              isLogin: dataSeller?.isLogin ?? false,
              ...(dataSeller?.status === 'REGISTERED' && {
                userId: dataSeller?.userId,
              }),
              ...(isEmail && {
                email: dataSeller?.email ?? phoneNumber,
              }),
            },
            trxDate: selectedDate,
          }
          const res = await axios.post(
            `${apiEndpoint}/api/v1/bussines/transaction/buy`,
            obj,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          )
          if (res.status === 200) {
            const obj = {
              ...response,
              dataComodities: updatedDataComodities,
              dataSeller: dataSeller,
              trxId: res?.data?.id,
              alreadyReceived: alreadyReceived,
              files: files.map((e) => e.fileUrl),
              fileNames: fileNames,
              trxDate: selectedDate,
            }
            localStorage.setItem('userData', JSON.stringify(obj))
            if (allPricesAreZero) {
              const escrowpaymentId = res?.data?.escrowpaymentId
              if (!escrowpaymentId && !res?.data?.id) {
                setErrMsg('Transaksi berhasil dibuat, tetapi ID transaksi tidak ditemukan.')
                return
              }
              localStorage.removeItem('userData')
              const uId = profile?.userId || ownerData?.userId
              if (uId) {
                localStorage.removeItem(`userData-${uId}`)
                localStorage.removeItem(`userDataBuy-${uId}`)
              }
              Object.keys(localStorage).forEach((key) => {
                if (key === 'userData' || key.startsWith('userData-') || key.startsWith('userDataBuy-')) {
                  localStorage.removeItem(key)
                }
              })
              // navigate('/transaksi-pembelian-sukses', {
              //   state: {
              //     title: 'Transaksi berhasil!',
              //     desc: 'Transaksi Anda telah selesai dibuat',
              //   },
              // })
              enqueueSnackbar('Transaksi berhasil!', {
                variant: 'success',
              })
              setTimeout(() => {
                if (escrowpaymentId) {
                  navigate(`${URL_DETAIL_TRANSACTION}/${escrowpaymentId}?type=BUY`)
                } else {
                  navigate(lastPath || '/')
                }
              }, 300)
            } else {
              navigate(
                `/transaksi-pembelian-pembayaran${isEmail ? '?isEmail=true' : ''}`,
              )
            }
          }
        }
      } else {
        setIsSubmitted(false)
        setIsSet(false)
      }
    } catch (error) {
      setIsSubmitted(false)
      setIsSet(false)
      setErrMsg(error?.response?.data?.message)
    }
  }

  const handleFinishedCheckNumber = (resp) => {
    if (resp) {
      setDataSeller({
        ...resp,
        profileStatus: 'UNVERFIED',
        status: 'UNREGISTERED',
        bankLogo: resp?.bankData?.logo,
        bankCode: resp?.bankData?.code,
        phoneNumber: phoneNumber,
      })
      toggleModal()
    }
  }

  const handleCbData = (resp) => {
    try {
      const checkUnits = resp?.dataComodities?.some((i) => {
        return !i.comodity || i.quantity < 1 || !i.unit
      })
      setDisable(checkUnits)
    } catch (error) {
      console.warn(error)
    }
  }

  const onRemove = () => {
    localStorage.removeItem(`userData-${profile?.userId}`)
    toggleOpenModalDraft()
  }

  const onConfirm = () => {
    const data = JSON.parse(localStorage.getItem(`userData-${profile?.userId}`))
    setDataSeller(data?.dataSeller)
    setAlreadyReceived(data?.alreadyReceived)
    setFiles(data?.files ?? [])
    setFileNames(data?.fileNames ?? [])
    setSelectedDate(data?.trxDate ?? moment(new Date()).format('YYYY-MM-DD'))
    setTempDraft(data)
    toggleOpenModalDraft()
  }

  useEffect(() => {
    const relationPhoneOrEmail =
      selectedContact?.relationPhoneNumber ?? selectedContact?.relationEmail
    if (relationPhoneOrEmail) {
      handleCheckNumber(relationPhoneOrEmail)
      setPhoneNumber(relationPhoneOrEmail)
    } else {
      setDataSeller('')
      // setPhoneNumber('')
      setErrMsgPhone('')
    }
  }, [selectedContact])

  useEffect(() => {
    dispatch(setNumberStep(1))
  }, [dispatch])

  useEffect(() => {
    if (profile?.userId) {
      const saved = JSON.parse(
        localStorage.getItem(`savedContacts-${profile?.userId}`),
      )
      setSavedContacts(saved ?? [])
    }
  }, [profile])

  // HANDLE AUTO FOCUS
  useEffect(() => {
    setTimeout(() => {
      addressBookRef.current?.focus()
    }, 0)
  }, [])

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem(`userData-${profile?.userId}`))
    // If we have prefill data from "Ulangi Pesanan", do NOT show draft modal
    if (
      !location?.state?.prefillOrders &&
      Number(data?.dataComodities[0]?.quantity) > 0
    ) {
      setIsOpenModalDraft(true)
    }
  }, [location?.state?.prefillOrders])

  useEffect(() => {
    if (location?.state?.prefillOrders) {
      const { prefillOrders, sellerPhoneNumber } = location.state
      // 1. Map prefillOrders to tempDraft structure
      const mappedComodities = (prefillOrders?.item || []).map((it) => ({
        unit: it?.unit
          ? { value: it.unit.value, label: it.unit.label }
          : { value: 'Kg', label: 'Kg' },
        quantity: it?.amount ? String(it.amount).replace('.', ',') : '',
        price: it?.price ? String(it.price).replace('.', ',') : '',
        totalPrice: it?.totalPrice || 0,
        comodity: {
          value: it?.itemId,
          label: it?.nameItem,
          id: it?.itemId,
          img: it?.imageUrl,
          sku: it?.SKU,
        },
      }))

      const mappedDraft = {
        dataComodities: mappedComodities,
        comodities: mappedComodities.map((_, idx) => ({ id: idx + 1 })),
        notes: prefillOrders?.order?.notes || '',
        customNumber: prefillOrders?.order?.transaction_number || '',
        project:
          { ...prefillOrders?.project, id: prefillOrders?.project?.value } ||
          null,
      }

      setTempDraft(mappedDraft)
      // trigger ComodityForm to load this "draft"
      // setIsDraftLoaded(false)
      // Note: `isDraftLoaded` is in ComodityForm, but we pass `tempDraft` as `dataDraft` prop.
      // ComodityForm reacts to `dataDraft` changes.

      // 2. Handle Seller Prefill
      if (sellerPhoneNumber) {
        handleCheckNumber(sellerPhoneNumber)
      }

      // Clear state to prevent re-run
      window.history.replaceState({}, document.title)
    }
  }, [location?.state])

  useEffect(() => {
    if (isSubmitted) return

    const updatedDataComodities = dataDraft?.dataComodities?.map((item) => ({
      ...item,
      price: item.price === '' ? 0 : item.price,
    }))

    const obj = {
      ...dataDraft,
      dataComodities: updatedDataComodities,
      dataSeller: dataSeller,
      alreadyReceived: alreadyReceived,
      files: files,
      fileNames: fileNames,
      trxDate: selectedDate,
    }
    if (
      dataSeller?.fullName ||
      files?.length > 0 ||
      fileNames?.length > 0 ||
      selectedDate !== moment(new Date()).local().format('YYYY-MM-DD') ||
      (!isSet && updatedDataComodities?.[0]?.quantity > 0)
    ) {
      localStorage.setItem(`userData-${profile?.userId}`, JSON.stringify(obj))
    }
  }, [dataDraft, isSet, dataSeller, files, fileNames, selectedDate])

  return (
    <div>
      <ModalUnverifSeller
        toggle={() => {
          toggleModal()
          setSelectedContact(null)
          // setPhoneNumber('')
          setDataSeller('')
          setPhoneNumber('')
          setErrMsgPhone('')
          setErrMsg('')
        }}
        isOpen={isOpenModal}
        handleFinished={handleFinishedCheckNumber}
        selectedContact={selectedContact}
      />
      <ModalAddContact
        isOpen={isModalOpenAddAddressBook}
        toggle={toggleOpenCloseAddContact}
        isOutsideAddressBook
      // isPhoneUnRegistered
      // isPhoneRegistered
      />
      <ModalDrafts
        isOpen={isOpenModalDraft}
        toggle={toggleOpenModalDraft}
        onConfirm={onConfirm}
        onRemove={onRemove}
        isMobile
      />
      <Container fluid className="custom-container mb-5 pb-5">
        <div className="d-flex flex-column gap-4">
          <Card className="border-0 shadow-sm" style={{ borderRadius: '12px' }}>
            <CardBody className="p-4">
              <CardTitle tag="h5" className="fw-bold mb-4" style={{ color: '#0f172a' }}>Pembelian</CardTitle>
              <FormGroup>
                <Label className="fw-semibold text-secondary">Tanggal Transaksi</Label>
                <div className="d-flex align-items-center justify-content-center border rounded">
                  <Calendar size={17} className="ms-3" />
                  <Flatpickr
                    options={{
                      locale: Indonesian,
                      dateFormat: 'd-M-Y',
                      defaultDate: new Date(),
                      maxDate: new Date(),
                      onClose: (selectedDate, dateStr, instance) => {
                        setSelectedDate(
                          moment(selectedDate[0]).local().format('YYYY-MM-DD'),
                        )
                      },
                    }}
                    className="form-control flat-picker bg-transparent border-0 shadow-none"
                    data-testid="transaction-date-input"
                  />
                </div>
              </FormGroup>

              <div className="mb-2" data-testid="transaction-seller-input">
                <InputAddressBook
                  onSelectContact={handleSelectedContact}
                  fieldName="relationName"
                  editValue={
                    selectedContact?.relationPhoneNumber
                      ? `${selectedContact?.relationName} (${selectedContact?.relationPhoneNumber})`
                      : selectedContact?.relationEmail
                        ? `${selectedContact?.relationName} (${selectedContact?.relationEmail})`
                        : selectedContact?.relationName
                  }
                  onClickAdd={(localSearch) =>
                    dispatch(setSearchAddressBook(localSearch))
                  }
                  isOutsideAddressBook
                  onFetchingChange={setIsFetchingAddressBook}
                  innerRef={addressBookRef}
                  isRecentTrx
                  isCloseSelection={dataSeller ?? tempDraft}
                  valueName={tempDraft?.dataSeller?.fullName}
                />
              </div>

              {errMsgPhone && (
                <small className="text-danger" data-testid="transaction-seller-error-message">
                  <AlertCircle size={15} />
                  {errMsgPhone}
                </small>
              )}
              {dataSeller && !isFetchingAddressBook ? (
                <>
                  <CardText
                    tag="h6"
                    className="fw-bold mb-2 mt-4"
                    style={{ paddingTop: errMsgPhone && '10px', color: '#334155' }}
                  >
                    Informasi Penjual
                  </CardText>
                  <Row className="g-3">
                    <Col xs="12" md="6">
                      <Card
                        className="border shadow-none"
                        style={{ minHeight: 76, borderRadius: '10px', borderColor: '#e2e8f0' }}
                      >
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-3">
                              <ProfilePic
                                imgSrc={
                                  dataSeller?.partnership?.logo ??
                                  dataSeller?.profileImg
                                }
                                altText={dataSeller?.partnership?.name ?? dataSeller?.fullName}
                                name={dataSeller?.partnership?.name ?? dataSeller?.fullName}
                                avatarSeed={dataSeller?.userId}
                                width={42}
                                height={42}
                              />
                              <div className="d-flex flex-column">
                                <span className="fw-bold text-dark" style={{ fontSize: '14px' }}>
                                  {dataSeller?.partnership?.name ??
                                    dataSeller?.fullName}
                                </span>
                                {dataSeller?.otherPicUser?.fullName && (
                                  <span className="text-secondary" style={{ fontSize: '12px' }}>
                                    PIC: {dataSeller?.otherPicUser?.fullName}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div
                              style={{
                                backgroundColor: dataSeller?.profileStatus === 'VERIFIED' ? '#dcfce7' : '#fef3c7',
                                color: dataSeller?.profileStatus === 'VERIFIED' ? '#15803d' : '#d97706',
                                padding: '4px 8px',
                                borderRadius: '6px',
                                fontSize: '11px',
                                fontWeight: 600
                              }}
                            >
                              {dataSeller?.profileStatus === 'VERIFIED'
                                ? 'Terverifikasi'
                                : 'Belum Terverifikasi'}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xs="12" md="6">
                      <Card
                        className="border shadow-none"
                        style={{ minHeight: 76, borderRadius: '10px', borderColor: '#e2e8f0' }}
                      >
                        <CardBody className="p-3">
                          <div className="d-flex justify-content-center flex-column h-100">
                            <div className="d-flex align-items-center gap-2 mb-1">
                              {dataSeller?.bankLogo && (
                                <img
                                  src={dataSeller?.bankLogo}
                                  alt="bank"
                                  width={24}
                                  height={24}
                                  style={{ objectFit: 'contain' }}
                                />
                              )}
                              <span className="fw-semibold text-dark" style={{ fontSize: '14px' }}>
                                {dataSeller?.bankAccountNumber}
                              </span>
                            </div>
                            <div
                              className="text-secondary fw-medium"
                              style={{ fontSize: '13px', marginLeft: dataSeller?.bankLogo ? '32px' : '0' }}
                            >
                              {dataSeller?.bankAccountName}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
            </CardBody>
          </Card>

          <div style={{ marginBottom: '32px' }}>
            <ComodityForm
              title="Barang yang dibeli"
              handleFinished={handleFinished}
              isSet={isSet}
              userData={userData}
              handleCbData={handleCbData}
              setDataDraft={setDataDraft}
              dataDraft={tempDraft}
            />
            {dataSeller?.profileStatus === 'VERIFIED' &&
              dataSeller?.status === 'REGISTERED' &&
              (!makePurchase || managePurchase) &&
              !dataSeller?.isLogin && (
                <Card className="border-0 shadow-sm">
                  <CardBody className="p-4">
                    <Input
                      type="checkbox"
                      name="barangDiterima"
                      onChange={(e) => {
                        if (alreadyReceived) {
                          setAlreadyReceived(false)
                          setFiles([])
                          setFileNames([])
                        } else {
                          setAlreadyReceived(true)
                        }
                      }}
                      checked={alreadyReceived}
                      data-testid="transaction-goods-received-checkbox"
                    />{' '}
                    Barang sudah diterima sebelum transaksi ini dibuat
                    {alreadyReceived ? (
                      <>
                        {' '}
                        <span className="d-flex mt-3">
                          Bukti barang sudah diterima{' '}
                          <span className="text-danger">*</span>
                        </span>
                        <Form
                          encType="multipart/form-data"
                          className="flex-centered border rounded"
                          style={{ overflow: 'hidden' }}
                        >
                          <fieldset className="fieldset">
                            <input
                              className="input-file"
                              id="transactions"
                              name="transactions"
                              data-testid="transaction-upload-proof-input"
                              onChange={async (e) => {
                                setErrMsg('')
                                const newFiles = e.target.files
                                if (newFiles.length > 3) {
                                  enqueueSnackbar(
                                    'Maksimal 3 file yang dapat diunggah',
                                    {
                                      variant: 'error',
                                    },
                                  )
                                  return
                                }

                                let newFileNames = []
                                let newUploadedFiles = []

                                for (let i = 0; i < newFiles.length; i++) {
                                  const uploadedFile = await dispatch(
                                    uploadFile(newFiles[i]),
                                  )

                                  if (uploadedFile.error) {
                                    enqueueSnackbar(
                                      uploadedFile?.payload || 'Upload gagal',
                                      {
                                        variant: 'error',
                                      },
                                    )
                                  } else {
                                    const fileId = Date.now() + i
                                    newFileNames.push({
                                      id: fileId,
                                      fileName: newFiles[i].name,
                                    })
                                    newUploadedFiles.push({
                                      id: fileId,
                                      fileUrl: uploadedFile?.payload?.url,
                                    })
                                  }
                                }

                                setFileNames((prev) => [
                                  ...prev,
                                  ...newFileNames,
                                ])
                                setFiles((prev) => [
                                  ...prev,
                                  ...newUploadedFiles,
                                ])
                              }}
                              type="file"
                              accept=".png, .jpeg, .jpg, .pdf"
                              multiple
                            />
                            <label htmlFor="transactions">Upload</label>
                          </fieldset>
                          <div
                            className="w-100"
                            style={{ padding: '10px 14px' }}
                          >
                            {fileNames?.length > 0
                              ? fileNames?.map((e, i) => (
                                <span className="ms-3 badge-line" key={i} data-testid={`transaction-upload-file-${e.id}`}>
                                  {e.fileName}
                                  <X
                                    size={16}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      setErrMsg('')
                                      const filteredFileNames =
                                        fileNames.filter(
                                          (file) => file.id !== e.id,
                                        )
                                      const filteredFiles = files.filter(
                                        (file) => file.id !== e.id,
                                      )
                                      setFileNames(filteredFileNames)
                                      setFiles(filteredFiles)
                                    }}
                                  />
                                </span>
                              ))
                              : 'Belum ada file'}
                          </div>
                        </Form>
                      </>
                    ) : (
                      <></>
                    )}
                  </CardBody>
                </Card>
              )}

            {errMsg && (
              <small className="text-danger">
                <AlertCircle size={15} /> {errMsg}
              </small>
            )}
          </div>
        </div>
      </Container>

      <PMBTotalFooter
        total={total}
        isLoading={isSubmitted}
        testId="transaction"
        isDisable={
          isSubmitted ||
          (total < 50000 && total !== 0) ||
          !dataSeller ||
          !userData ||
          disable ||
          (alreadyReceived ? files?.length === 0 : false)
        }
        onSubmit={() => {
          setIsSet(true)
        }}
      />
    </div>
  )
}

export default AddComodity
